<span *ngIf="text" class="column-text" [style.color]="color">{{text}}</span>
